import { withStyles } from '@material-ui/core/styles';

export default withStyles(() => ({
  disabledAlumyText: {
    color: 'rgba(0, 0, 0, 0.38)',
    pointerEvents: 'none',
  },
}));
